/*
 * @Author: xieyu7 
 * @Date: 2019-01-09 16:02:52 
 * @Last Modified by: hanjin
 * @Last Modified time: 2022-08-22 11:34:05
 */

const layout = {

  'normal': {
    _meta: {
      'tab': { key: '\t', text: 'Tab', width: 60, classes: 'control'},
      'shiftl': { keySet: 'shifted', text: 'Shift', width: 100, classes: 'control'},
      'shiftr': { keySet: 'shifted', text: 'Shift', width: 100, classes: 'control'},
      'caps': { keySet: 'capsed', text: 'Caps lock', width: 80, classes: 'control'},
      'space': { key: ' ', text: 'Space', width: 180},
      'enter': { key: '\r\n', text: 'Enter', width: 80, classes: 'control'},
      'backspace': { func: 'backspace', classes: 'control iconfont icon-ios-backspace', width: 65},
      'close': { func: 'close', text: 'Close', classes: 'control featured'},
      'next': { func: 'next', text: 'Next', classes: 'control featured'}
    },

    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {backspace}',
      // "{tab} q w e r t y u i o p [ ]",
      '{tab} q w e r t y u p [ ]',
      '{caps} a s d f g h j k l ; \' \\ {enter}',
      '{shiftl} z x c v b n m , . / {shiftr}',
      ' {space} {close}'
    ],
    shifted: [
      '~ ! @ # $ % ^ & * ( ) _ + {backspace}',
      // "{tab} Q W E R T Y U I O P { }",
      '{tab} Q W E R T Y U P { }',
      '{caps} A S D F G H J K L : " | {enter}',
      '{shiftl} Z X C V B N M < > ? {shiftr}',
      ' {space} {close}'
    ],
    capsed: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {backspace}',
      // "{tab} Q W E R T Y U I O P [ ]",
      '{tab} Q W E R T Y U P [ ]',
      '{caps} A S D F G H J K L ; \' \\ {enter}',
      '{shiftl} Z X C V B N M , . / {shiftr}', 
      ' {space} {close}'
    ]		
  },

  'compact': {
    _meta: {
      'default': { keySet: 'default', text: 'abc', classes: 'control'},
      'alpha': { keySet: 'default', text: 'Abc', classes: 'control'},
      'shift': { keySet: 'shifted', text: 'ABC', classes: 'control'},
      'numbers': { keySet: 'numbers', text: '123', classes: 'control', width:'80'},
      'space': { key: ' ', text: 'Space', width: 200},
      'backspace': { func: 'backspace', classes: 'control iconfont icon-ios-backspace'},
      'close': { func: 'close', text: 'Close', classes: 'control featured', width:'80'},
      'next': { func: 'next', text: 'Next', classes: 'featured'},
      'zero': { key: '0', width: 80, text: '0'}
    },
    default: [
      '1 2 3 4 5 6 7 8 9 0',
      // "q w e r t y u i o p",
      'q w e r t y u p',
      '{shift} a s d f g h j k l {backspace}',
      '{numbers} z x c v b n m {close}'
    ],
    shifted: [
      '1 2 3 4 5 6 7 8 9 0',
      // "Q W E R T Y U I O P",
      'Q W E R T Y U P',
      '{default} A S D F G H J K L {backspace}',
      '{numbers} Z X C V B N M {close}'
    ],
    numbers: [
      '1 2 3',
      '4 5 6',
      '7 8 9',
      '{alpha} {zero} {close} {backspace}'
    ]
  },

  'number': {
    _meta: {
      'backspace': { func: 'backspace', classes: 'control iconfont icon-ios-backspace'},
      'close': { func: 'close', text: 'Close', classes: 'control featured'},
      'next': { func: 'next', text: 'Next', classes: 'control featured'},
      'zero': { key: '0', width: 130}
    },
    default: [
      '1 2 3',
      '4 5 6',
      '7 8 9',
      '{zero} {close} {backspace}'
    ]
  },
  /* 添加车牌用键盘配置项 */
  'area': {
    _meta: {
      /* 功能键 */
      'backspace': { func: 'backspace', classes: 'control', text: '删除', width: 90},
      'ABCnotouch': { classes: 'notouch', text:'ABC',width: 85},
      'ABC': { keySet: 'abcOn', classes: 'control', text:'ABC',width: 85},
      '省份notouch': { classes: 'notouch', text:'省份',width: 85},
      '省份': { keySet: 'defaultOn', classes: 'control', text:'省份',width: 85},
      '殊notouch': { classes: 'notouch',text:'殊' },
      '殊': {func: 'special', classes: 'control',text:'殊' },
      /* 特殊字符键 */
			
      'WJnotouch': {classes: 'notouch', text:'WJ', key: 'WJ'},
      '1': {classes: 'notouch', text:'1', key: '1'},
      '2': {classes: 'notouch', text:'2', key: '2'},
      '3': {classes: 'notouch', text:'3', key: '3'},
      '4': {classes: 'notouch', text:'4', key: '4'},
      '5': {classes: 'notouch', text:'5', key: '5'},
      '6': {classes: 'notouch', text:'6', key: '6'},
      '7': {classes: 'notouch', text:'7', key: '7'},
      '8': {classes: 'notouch', text:'8', key: '8'},
      '9': {classes: 'notouch', text:'9', key: '9'},
      '0': {classes: 'notouch', text:'0', key: '0'},
      '港': {classes: 'notouch', text:'港'},
      '澳': {classes: 'notouch', text:'澳'},
      '学': {classes: 'notouch', text:'学'},
      '挂': {classes: 'notouch', text:'挂'},
      '警': {classes: 'notouch', text:'警'},
      '应急': {classes: 'notouch', text:'应急'}
    },
    default: [
      '京 津 冀 晋 蒙 辽 吉 黑 沪 苏',
      '浙 皖 闽 赣 鲁 豫 鄂 湘 粤 桂',
      '琼 渝 川 黔 滇 藏 陕 甘 青 宁',
      '新 云 贵 {WJnotouch}   {ABCnotouch} {backspace}'
    ],
    defaultOn: [
      '京 津 冀 晋 蒙 辽 吉 黑 沪 苏',
      '浙 皖 闽 赣 鲁 豫 鄂 湘 粤 桂',
      '琼 渝 川 黔 滇 藏 陕 甘 青 宁',
      '新 云 贵 WJ   {ABC} {backspace}'
    ],
    abc: [
      '{1} {2} {3} {4} {5} {6} {7} {8} {9} {0}',
      // "Q W E R T Y U I O P",
      'Q W E R T Y U O P',
      'A S D F G H J K L Z',
      'X C V B N M {殊} {省份notouch} {backspace}'
    ],
    abcOn: [
      '{1} {2} {3} {4} {5} {6} {7} {8} {9} {0}',
      // "Q W E R T Y U I O P",
      'Q W E R T Y U O P',
      'A S D F G H J K L Z',
      'X C V B N M {殊} {省份} {backspace}'
    ],
    numOn: [
      '1 2 3 4 5 6 7 8 9 0',
      // "Q W E R T Y U I O P",
      'Q W E R T Y U P',
      'A S D F G H J K L Z',
      'X C V B N M {殊} {省份} {backspace}'
    ],
    num: [
      '1 2 3 4 5 6 7 8 9 0',
      // "Q W E R T Y U I O P",
      'Q W E R T Y U P',
      'A S D F G H J K L Z',
      'X C V B N M {殊} {省份notouch} {backspace}'
    ],
    xue: [
      '1 2 3 4 5 6 7 8 9 0',
      // "Q W E R T Y U I O P",
      'Q W E R T Y U P',
      'A S D F G H J K L Z',
      'X C V B N M {殊} {省份} {backspace}'
    ],
    /* 【殊】 第二键盘布局 */
    off: ['{港} {澳} {学} {警} {应急} {挂}'],
    XUE: ['{港} {澳} 学 {警} {应急} 挂'],
    GA: ['港 澳 {学} {警} {应急} {挂}'],
    GAJ: ['港 澳 学 警 应急 挂'],
    YJ: ['{港} {澳} {学} 警 应急 {挂}'],
    XUEJ: ['{港} {澳} 学 警 应急 挂']
  }
}

export default layout